var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row items-center q-pb-md q-pt-md"},[_c('p',{class:[_vm.color, 'text-h6 q-pr-md']},[_vm._v(_vm._s(_vm.category.name))]),_c('div',{staticClass:"gradient q-ml-md"})])}
var staticRenderFns = []

export { render, staticRenderFns }